const About = () => {
    return (
      <section>
        <div className='about-text'>
        <h1>About Space Page</h1>
        <p>
          Developed by Arthur Ruxton and Ed Chamberlain to be the one and only place for space. 
        </p>
        </div>
        <p> Click the icon to play Hannah Hill's Space Invaders game </p>
          <div className='space-invade'>
            <a href="https://hannah-hill.github.io/space-invaders/" >
            <img src='https://i.imgur.com/7sBwSSV.png' alt="space invader"/>
           </a>
          </div>
      </section>
    )
  }
  
  
  export default About
  